import { useCallback, useEffect, useRef } from 'react';
import { constVoid } from 'fp-ts/lib/function';
import { getABSmartlyId, getUserId } from '../Cookie';
import { trackVisitorEvent } from '../Tracking';
export const VISITOR_EVENT = 'visitor';
/**
 *
 * Hook to track visitor events,
 * being used to track visitor events like visit_lotdetail and visitor,
 * and is sent
 *
 * @example
 *
 * import { useTrackVisitorEvents } from '@catawiki/runtime-toolkit';
 *
 * const locale = SupportedLocale.English;
 * const lotId = 123456;
 *
 * useTrackVisitorEvents(locale, params: { lotId });
 */
export const useTrackVisitorEvents = (locale, options) => {
    const isEventSent = useRef(false);
    const anonymousId = getABSmartlyId();
    const userAgent = globalThis.navigator?.userAgent || 'NodeJS';
    const userId = getUserId();
    const { retrigger, eventName, params } = options || {};
    const sendEvent = useCallback(() => {
        if (!anonymousId) {
            return false;
        }
        trackVisitorEvent({
            event: eventName,
            userAgent,
            locale,
            userId,
            anonymousId,
            ...params,
        }).catch(constVoid);
        return true;
    }, [userAgent, locale, userId, anonymousId, eventName, params]);
    useEffect(() => {
        if (isEventSent.current)
            return;
        if (sendEvent()) {
            isEventSent.current = true;
        }
    }, [locale, anonymousId, sendEvent, userId, userAgent]);
    useEffect(() => {
        if (retrigger && anonymousId) {
            if (sendEvent()) {
                isEventSent.current = true;
            }
        }
    }, [retrigger, sendEvent, anonymousId]);
};
